module.exports = "#btnPrevious {\n  margin-right: 5vw; }\n"